module.exports = __webpack_public_path__ + "img/salmon_crudo_topping.3ded0cd5.jpg";